import { AuthContext } from "./types";

export const DefaultValue: AuthContext = {
    values: {
        isLogin: "PENDING",
        token: "",
        id: "",
    },
    actions: {
        handleLogin: () => {},
        handleLogout: () => {},
    },
};
